import { Flex } from 'components/Flex';
import ApDevicePanelContainer from 'modules/bottomPanel/containers/ApDevicePanel';
import ClientDevicePanelContainer from 'modules/bottomPanel/containers/ClientDevicePanel';
import WifiPanelResults from 'modules/bottomPanel/containers/WifiPanelResultsDisplay';

const WifiBottomMobilePanel = () => (
  <Flex gap="l" column>
    <WifiPanelResults ApDevicePanel={ApDevicePanelContainer} ClientDevicePanel={ClientDevicePanelContainer} />
  </Flex>
);

export default WifiBottomMobilePanel;
